/**
 * @flow
 * @relayHash 27c94bc86d76387f80c38491c4b331df
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeletePOApprovalRuleInput = {|
  poApprovalRuleId: string
|};
export type DeletePOApprovalRuleMutationVariables = {|
  input: DeletePOApprovalRuleInput
|};
export type DeletePOApprovalRuleMutationResponse = {|
  +deletePOApprovalRule: {|
    +success: boolean
  |}
|};
export type DeletePOApprovalRuleMutation = {|
  variables: DeletePOApprovalRuleMutationVariables,
  response: DeletePOApprovalRuleMutationResponse,
|};
*/


/*
mutation DeletePOApprovalRuleMutation(
  $input: DeletePOApprovalRuleInput!
) {
  deletePOApprovalRule(input: $input) {
    success
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeletePOApprovalRuleInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deletePOApprovalRule",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeletePOApprovalRulePayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "success",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeletePOApprovalRuleMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeletePOApprovalRuleMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeletePOApprovalRuleMutation",
    "id": null,
    "text": "mutation DeletePOApprovalRuleMutation(\n  $input: DeletePOApprovalRuleInput!\n) {\n  deletePOApprovalRule(input: $input) {\n    success\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '3e087fce4d4a9c14d7010e319f1a427d';
module.exports = node;
